// extracted by mini-css-extract-plugin
module.exports = {"productImage":"Offerings_productImage__2rR3g"};